module.exports = __webpack_public_path__ + "media/images/expedia-4175bb1b.png";